import { Ticket, Zap, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useGoTo } from "@/lib/useGoTo";
import { WHATSAPP_NUMBER } from "@/data/zoneDetails";

export const FloatingDock = () => {
  const go = useGoTo();
  const contact = () => (WHATSAPP_NUMBER ? window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank") : go("enquire"));
  const items = [
    { id: "book", label: "Book Now", icon: Ticket, onClick: () => go("book"), cls: "bg-[#FFEF00] text-black" },
    { id: "recharge", label: "Recharge", icon: Zap, onClick: () => go("recharge"), cls: "bg-[#14C3F7] text-black" },
    { id: "contact", label: WHATSAPP_NUMBER ? "WhatsApp" : "Contact", icon: MessageCircle, onClick: contact, cls: "bg-white text-black" },
  ];
  return (
    <>
      <motion.div initial={{ x: 80, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: 1.4, duration: 0.6 }}
        className="hidden lg:flex fixed right-2 top-1/2 -translate-y-1/2 z-40 flex-col items-end gap-3" data-testid="floating-dock">
        {items.map((it) => (
          <button key={it.id} data-testid={`dock-${it.id}`} onClick={it.onClick}
            className={`group flex items-center justify-end gap-0 hover:gap-2 rounded-full border-[2.5px] border-black shadow-[2px_2px_0_#000] h-10 pl-2 pr-2 ${it.cls} transition-[gap] duration-300`}>
            <span className="max-w-0 group-hover:max-w-[120px] overflow-hidden whitespace-nowrap font-display font-bold text-xs transition-[max-width] duration-300">{it.label}</span>
            <it.icon size={18} />
          </button>
        ))}
      </motion.div>
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 gap-2 p-2.5 bg-[#07080E]/90 backdrop-blur-xl border-t border-white/10" data-testid="mobile-dock">
        {items.map((it) => (
          <button key={it.id} data-testid={`mobile-dock-${it.id}`} onClick={it.onClick}
            className={`flex items-center justify-center gap-1.5 rounded-full border-2 border-black py-3 font-display font-bold text-xs ${it.cls}`}>
            <it.icon size={16} /> {it.label}
          </button>
        ))}
      </div>
    </>
  );
};
